
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';

import styles from './investment-detail.module.scss';
import numToWords from '../../../../helpr/numToWords';
import { toCurrency } from '../../../../helpr/helper';
import { Connect } from 'aws-sdk';


export const InvestmentDetail = ({issuer, issue, offerPeriod, issueLogo, purchaseAmount, currencyType}) => {
  const cType = currencyType ? currencyType : 'PHP';
  const currency = purchaseAmount != null && !isNaN(purchaseAmount) ? purchaseAmount : 0;
  const displayAmnt = purchaseAmount != null && !isNaN(purchaseAmount) ?  numToWords()(purchaseAmount) : '-';;

  return (
    <div className={styles['investment-detail']}>
      <div className={styles['investment-detail-header']}>
        RESERVATION DETAIL
      </div>
      <div className={styles['investment-detail-logo']}>
        <img src={`${process.env.REACT_APP_ASSETS_URL}${issueLogo}`}/>
      </div>
      <div className={styles["investment-detail-body"]}>
        <Row className="mt-3">
          <Col>
            <div className={styles['info']}>Issuer Name</div>
          </Col>
          <Col>
            <div className={styles['info']}>{issuer}</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={styles['info']}>Security Name</div>
          </Col>
          <Col>
            <div className={`${styles['info']} ${styles['wrap']}`}>{issue}</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={styles['info']}>Start of Offer Period</div>
          </Col>
          <Col>
            <div className={styles['info']}>{offerPeriod}</div>
          </Col>
        </Row>
      </div>
      <div className={styles['investment-detail-amount']}>
        <div className={styles['investment-detail-amount-header']}>
          TOTAL RESERVATION AMOUNT
        </div>
        <div className={styles['investment-detail-amount-info']}>
          <div className={styles['digit-value']}>
            { cType + ' ' + toCurrency(parseFloat(currency).toFixed(2)) }
          </div>
          <div className={styles['string-value']}>
            { displayAmnt }
          </div>
        </div>
      </div>
    </div>
  )
}

const Investment = ({session, purchaseAmount , setPurchaseAmount, nextStep}) => {
  /*
    Amount to purchase validation rule
  */
  const MIN_DENOMINATION = session['minimumDenomination'] ? session['minimumDenomination'] : 10000;
  const MIN_INCREMENTS = session['minimumIncrements'] ? session['minimumIncrements'] : 5000;
  const initAmountInWords = purchaseAmount == null ? null : numToWords()(purchaseAmount);
  const [inFigures, setInFigures] = useState(purchaseAmount);
  const [amountWords, setAmountWords] = useState(initAmountInWords);
  const [invalidFormFlag, setInvalidFormFlag] = useState(0);
  const errorMessages = [
    null,
    "Minimum denomination should be " + toCurrency(MIN_DENOMINATION),
    "Purchase amount should have increments of " + toCurrency(MIN_INCREMENTS)
  ]

  const isFormValid = () => {
    // Validate Input Not Null
    if(inFigures == null || inFigures == '' || isNaN(inFigures))
      return false;
    return true;
  }

  const onNextClick = () => {
    if(parseFloat(inFigures) < MIN_DENOMINATION){
      setInvalidFormFlag(1);
      return false;
    }
    else if(parseFloat(inFigures) % MIN_INCREMENTS != 0){
      setInvalidFormFlag(2);
      return false;
    }
    else {
      setPurchaseAmount(parseFloat(inFigures));
      nextStep();
    }
  }

  const addCommas = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  const [figuresString, setFiguresString] = useState(inFigures);
  const toTitleCase = (str) => {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
  const parseFigureString = (inputValue) => {
    const regexValidation = /^[0-9,]+$/;
    if(inputValue.match(regexValidation) || inputValue == null || inputValue == ''){
      const nonSpaceValue = inputValue == '' ? null : inputValue;
      const nonCommaValue = nonSpaceValue? nonSpaceValue.replace(/,/gi,''): '';
      const numString = addCommas(nonCommaValue);
      const numericValue = parseFloat(nonCommaValue);

      setFiguresString(numString);
      setInFigures(parseFloat(nonCommaValue));
      setAmountWords(toTitleCase(numToWords()(numericValue)));
    }
  }

  const onFieldChange = (e) => {
    parseFigureString(e.target.value);
  }

  useEffect(()=>{
    parseFigureString(figuresString === null ? '' : figuresString.toString());
  },[])

  return (
    <div className={styles['invest-component']}>
      <Row>
        <Col sm={12} lg={8}>
          <div className={styles['invest-component-form']}>
            <div className={styles['logo']}>
              <img src={`${process.env.REACT_APP_ASSETS_URL}${session.securityLogoSrc }`}/>
            </div>
            <div className={styles['body']}>
              <div className={styles['detail']}>
                <div className={styles['header']}>
                  { session['securityIssuer'] }
                </div>
                <div className={`${styles['info']} ${styles['wrap']}`}>
                  { session['securityName'] }
                </div>
                <div className={styles['info']}>
                  { session['securityOfferDate'] }
                </div>
              </div>
              <div className={styles['form']}>
                <div className={styles['header']}>
                  RESERVATION AMOUNT
                </div>
                <div className={styles['fields']}>
                  { invalidFormFlag != 0 && (<label className={styles['error-msg']}> { errorMessages[invalidFormFlag] }</label>) }
                  <input type="text" autoComplete="off" step="1" placeholder="In Figures" value={figuresString !== null? figuresString : ''} onChange={onFieldChange}/>
                  <div className={styles['capitalize']}>
                    <input type="text" autoComplete="off" placeholder="In Words" value={amountWords !== null? amountWords: ''} disabled/>
                  </div>
                  </div>
                <div className={styles['action']}>
                  <Button variant="primary" onClick={()=>onNextClick()} disabled={!isFormValid()}>NEXT</Button>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <InvestmentDetail
            issuer={session['securityIssuer']}
            issue={session['securityName']}
            issueLogo={session.securityLogoSrc}
            offerPeriod={session['securityOfferDate']}
            purchaseAmount={inFigures}
            currencyType={session['currency']}
          />
        </Col>
      </Row>
    </div>
  )

}

export default Investment;



